export const packages = [
  {
    quantity: '100',
    price: '275.00',
  },
  {
    tag: 'Mas popular',
    quantity: '250',
    price: '415.00',
  },
  {
    quantity: '500',
    price: '715.00',
  },
  {
    quantity: '1000',
    price: '1,100.00',

  },
  {
    quantity: '2500',
    price: '2,695.00',
  },
  {
    quantity: '5000',
    price: '4,675.00',
  },
];
